import axios from 'axios';

interface IGetJsonOptions {
  dev?: boolean;
  cache?: boolean;
}

export const getJson = async <T>(name: string, options?: IGetJsonOptions) => {
  // @ts-ignore
  const dev = import.meta.env.VITE_DEV === 'true' && options?.dev !== false;
  let url;
  if (dev) {
    url = `http://localhost:5173/${name}.json`;
  } else {
    // @ts-ignore
    url = `${import.meta.env.VITE_OSS}/${name}.json`;
    if (options?.cache !== true) {
      url += `?t=${Date.now()}`;
    }
  }
  const res = await axios.get(url);
  return res.data as T;
};
